// Mock data for the Fokatmain marketing website

export const featuredGames = [
  {
    id: 1,
    title: "Lightning Quiz",
    description: "Answer 10 questions in 90 seconds",
    entryFee: 10,
    duration: "90s",
    playersToday: 1247,
    timeLeft: "2h 45m",
    deadline: "Ends today at 11:59 PM",
    image: "/game-icons/quiz.png",
    category: "Knowledge"
  },
  {
    id: 2,
    title: "Spin Master", 
    description: "Time your spin perfectly to win",
    entryFee: 10,
    duration: "60s",
    playersToday: 892,
    timeLeft: "5h 12m",
    deadline: "Ends today at 11:59 PM",
    image: "/game-icons/spin.png",
    category: "Timing"
  },
  {
    id: 3,
    title: "Tap Precision",
    description: "Hit targets with perfect accuracy", 
    entryFee: 10,
    duration: "120s",
    playersToday: 1563,
    timeLeft: "3h 33m",
    deadline: "Ends today at 11:59 PM",
    image: "/game-icons/tap.png",
    category: "Reflexes"
  }
];

export const recentWinners = [
  {
    id: 1,
    name: "R***h",
    city: "Mumbai",
    prize: "Wireless Earbuds",
    prizeImage: "/prizes/airpods.jpg",
    game: "Lightning Quiz",
    date: "2 hours ago",
    score: 9800
  },
  {
    id: 2,
    name: "S***a",
    city: "Delhi",
    prize: "Smart Watch",
    prizeImage: "/prizes/watch.jpg",
    game: "Spin Master",
    date: "5 hours ago",
    score: 9650
  },
  {
    id: 3,
    name: "A***t",
    city: "Bangalore",
    prize: "Wireless Headphones",
    prizeImage: "/prizes/headphones.jpg",
    game: "Tap Precision",
    date: "1 day ago",
    score: 9750
  },
  {
    id: 4,
    name: "P***l",
    city: "Pune",
    prize: "Mobile Phone",
    prizeImage: "/prizes/iphone.jpg",
    game: "Lightning Quiz",
    date: "2 days ago",
    score: 9900
  },
  {
    id: 5,
    name: "M***i",
    city: "Hyderabad",
    prize: "Smart Watch",
    prizeImage: "/prizes/macbook.jpg",
    game: "Mega Tournament",
    date: "3 days ago",
    score: 9950
  },
  {
    id: 6,
    name: "K***r",
    city: "Chennai",
    prize: "Wireless Earbuds",
    prizeImage: "/prizes/ps5.jpg",
    game: "Weekend Special",
    date: "1 week ago",
    score: 9850
  }
];

export const availablePrizes = [
  {
    id: 1,
    name: "iPhone 15 Pro Max",
    brand: "Apple",
    value: "₹1,59,900",
    image: "/prizes/iphone-15.jpg",
    category: "Smartphones",
    description: "Latest iPhone with Pro camera system"
  },
  {
    id: 2,
    name: "MacBook Pro M3",
    brand: "Apple", 
    value: "₹1,99,900",
    image: "/prizes/macbook-pro.jpg",
    category: "Laptops",
    description: "Professional laptop for creators"
  },
  {
    id: 3,
    name: "PlayStation 5 Pro",
    brand: "Sony",
    value: "₹54,990",
    image: "/prizes/ps5-pro.jpg", 
    category: "Gaming",
    description: "Next-gen gaming console"
  },
  {
    id: 4,
    name: "AirPods Pro 2nd Gen",
    brand: "Apple",
    value: "₹24,900",
    image: "/prizes/airpods-pro.jpg",
    category: "Audio",
    description: "Premium wireless earbuds"
  },
  {
    id: 5,
    name: "Apple Watch Ultra 2",
    brand: "Apple",
    value: "₹89,900", 
    image: "/prizes/watch-ultra.jpg",
    category: "Wearables",
    description: "Advanced fitness and adventure watch"
  },
  {
    id: 6,
    name: "Sony WH-1000XM5",
    brand: "Sony",
    value: "₹34,990",
    image: "/prizes/sony-headphones.jpg",
    category: "Audio", 
    description: "Industry-leading noise cancellation"
  }
];

export const brandPartners = [
  {
    id: 1,
    name: "Apple",
    logo: "/brands/apple-logo.svg",
    partnershipType: "Premium Sponsor"
  },
  {
    id: 2,
    name: "Samsung",
    logo: "/brands/samsung-logo.svg", 
    partnershipType: "Technology Partner"
  },
  {
    id: 3,
    name: "Sony",
    logo: "/brands/sony-logo.svg",
    partnershipType: "Gaming Partner"
  },
  {
    id: 4,
    name: "OnePlus",
    logo: "/brands/oneplus-logo.svg",
    partnershipType: "Mobile Partner"
  },
  {
    id: 5,
    name: "Boat",
    logo: "/brands/boat-logo.svg",
    partnershipType: "Audio Partner"
  },
  {
    id: 6,
    name: "Noise",
    logo: "/brands/noise-logo.svg",
    partnershipType: "Wearable Partner"
  }
];

export const gameStats = {
  totalPlayers: "50,000+",
  gamesPlayed: "2.5M+", 
  prizesWon: "15,000+",
  totalPrizeValue: "₹5Cr+",
  averageGameTime: "90s"
};

export const testimonials = [
  {
    id: 1,
    name: "Rahul Sharma",
    city: "Mumbai",
    avatar: "/avatars/rahul.jpg",
    prize: "Mobile Phone",
    quote: "I couldn't believe I won a mobile phone just by playing skill games! Fokatmain is absolutely legit.",
    rating: 5,
    game: "Lightning Quiz"
  },
  {
    id: 2,
    name: "Priya Patel", 
    city: "Ahmedabad",
    avatar: "/avatars/priya.jpg",
    prize: "Smart Watch",
    quote: "The games are so addictive and fair. Won my smart watch after just 3 weeks of playing!",
    rating: 5,
    game: "Spin Master"
  },
  {
    id: 3,
    name: "Arjun Singh",
    city: "Delhi",
    avatar: "/avatars/arjun.jpg", 
    prize: "Wireless Earbuds",
    quote: "Finally a gaming platform that rewards skill. The delivery was super fast too!",
    rating: 5,
    game: "Tap Precision"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Is Fokatmain gambling or betting?",
    answer: "No! Fokatmain is a skill-based gaming platform. Winners are determined by skill, speed, and accuracy - not luck. We only offer gadget prizes, never cash, making it completely different from gambling."
  },
  {
    id: 2,
    question: "How are winners decided?",
    answer: "Winners are determined by the highest scores, fastest completion times, or best performance based on each game's specific rules. All games have transparent scoring systems and anti-cheat measures."
  },
  {
    id: 3,
    question: "How do I receive my prize?",
    answer: "After winning, you'll need to complete KYC verification and provide your shipping address. Prizes are shipped within 7-14 business days via our logistics partners."
  },
  {
    id: 4,
    question: "What payment methods do you accept?",
    answer: "We accept UPI, Paytm, Razorpay, and all major digital payment methods. Entry fees are just ₹10 per game."
  },
  {
    id: 5,
    question: "Can I get refunds?",
    answer: "Entry fees are generally non-refundable as games start immediately. However, refunds may be provided in case of technical issues or service errors."
  },
  {
    id: 6,
    question: "Is there an age limit?",
    answer: "Yes, you must be 18+ to play on Fokatmain. We verify age during the registration process."
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Sign Up",
    description: "Quick registration with phone OTP or Google sign-in",
    icon: "UserPlus",
    detail: "Create your account in under 30 seconds with secure authentication"
  },
  {
    step: 2, 
    title: "Play Games",
    description: "Play available skill-based games (1-2 minutes each)",
    icon: "Gamepad2",
    detail: "Admin decides which games are open for competition. All games available in free practice mode!"
  },
  {
    step: 3,
    title: "Top Leaderboard", 
    description: "Use your skills to achieve the highest score",
    icon: "Trophy",
    detail: "Games require speed, knowledge, or precision - not luck"
  },
  {
    step: 4,
    title: "Win Gadgets",
    description: "Get real gadgets delivered to your doorstep",
    icon: "Gift", 
    detail: "No cash prizes - only premium gadgets and electronics"
  }
];